import {
  FormControlLabel,
  FormControlLabelProps,
} from 'shared/mui/FormControlLabel/FormControlLabel';
import { Switch } from 'shared/mui/Switch';

type Props = Omit<FormControlLabelProps, 'control' | 'label'>;

export const RequestsBankOpsRelatedSwitcher: React.FC<Props> = ({
  checked,
  onChange,
  value,
  ...rest
}) => {
  return (
    <FormControlLabel
      checked={checked}
      control={<Switch size="small" />}
      label="Смежная банковская операция"
      onChange={onChange}
      value={value}
      {...rest}
    />
  );
};
